<template>
  <div>
    <!-- Changelog dialog button with unread count badge -->
    <button class="changelog-button" @click="toggleChangelogDialog">
      <span class="changelog-button__label">
        <svg
          width="14"
          height="20"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.80028 1L1 12H7L6.19972 19L13 8H7L7.80028 1Z"
            stroke="inherit"
            stroke-width="0.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        What's new
      </span>
      <ChangelogBadge class="changelog-button__badge" :view="view" />
    </button>
    <Teleport to="#appRoot">
      <ChangelogPopup ref="popupChangelog" :view="view" />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import ChangelogPopup from './Popup.vue'
import ChangelogBadge from '@/app/components/changelog/Badge.vue'
import { ChangelogView } from '@/models/changelog'
import { assertNotNull } from '@/helpers/typing'
import type { HeaderView } from '@/models/header'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'
const props = defineProps<{
  view: ChangelogView
  headerView: HeaderView
}>()

const popupChangelog = ref<InstanceType<typeof ChangelogPopup> | null>(null)

async function toggleChangelogDialog(): Promise<void> {
  await props.view.loadData()
  props.headerView.toggle()
  assertNotNull(popupChangelog.value).show()
  Mixpanel.trackChangelogButtonClick()
}
</script>

<style lang="scss" scoped>
.changelog-button {
  display: flex;
  align-items: center;
  stroke: $c-black-2;
  flex-grow: 1;
  justify-content: flex-start;

  &__label {
    margin-right: 8px;
    font-size: 15px;
    display: flex;
    gap: 12px;
    color: $c-black-2;
  }

  &__badge {
    display: block;
  }
}

.night-mode .changelog-button {
  color: white;
  stroke: white;

  &__label {
    color: white;
  }
}
</style>
